module.exports = __webpack_public_path__ + "static/media/ecu-grey.5213f23c.svg";